export default (state = 0, action) => {
  switch (action.type) {
    case "counter/count":
      return (state += 1);
    default:
      return state;
  }
};
